import React from "react";
import styled from "styled-components";
import moment from "moment";
import { connect } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";
import { updateNote, deleteNote } from "store/state/note";

const NoteStyles = styled.div`
  margin: 1em;
  font-size: 17px;
  border-bottom: 1px solid;
  color: #ccc;

  h4 {
    margin: 0;
    color: black;
    line-height: 1;
    padding-right: 10px;
  }
  p {
    font-size: 17px;
    font-weight: 300;
    color: #000;
    white-space: pre-wrap;
  }
  .icon {
    font-size: 17px;
  }
  .icon:hover {
    cursor: pointer;
  }
  .icon.delete:hover {
    color: #ee3135;
  }
  .icon.edit:hover {
    color: #000;
  }
  .notes-header-container {
    display: flex;
    width: 100%;
  }
  .notes-container:hover .notes-header-container span {
    background-color: #fff;
    display: inline-block;
  }
  .notes-header-container span {
    margin-left: auto;
    height: 12px;
    display: none;
  }
  .editFields button {
    border: 1px solid #ccc;
  }
  .textArea {
    white-space: pre-wrap;
    width: -webkit-fill-available;
  }
`;

const Note = class extends React.Component {
  state = {
    editNote: false,
    updatedNoteText: ""
  };

  handleDelete = () => {
    const {
      note: { id, model, modelId }
    } = this.props;
    this.props.deleteNote({
      note: this.state.updatedNoteText,
      id,
      model,
      modelId
    });
  };

  handleEdit = () => {
    this.setState({ editNote: true });
  };

  handleUpdateNote = () => {
    const {
      note: { id, model, modelId }
    } = this.props;
    this.props.updateNote({
      note: this.state.updatedNoteText,
      id,
      model,
      modelId
    });
    this.setState({ editNote: false });
  };

  handleCancel = () => {
    this.setState({ editNote: false });
  };

  render() {
    const {
      note: { note, user, createdAt, updatedAt }
    } = this.props;
    const { editNote } = this.state;

    return (
      <NoteStyles>
        <div className="notes-container">
          <div className="notes-header-container">
            <h4>{user.name}</h4>
            <span>
              <EditIcon className="icon edit" onClick={this.handleEdit} />{" "}
              <DeleteIcon className="icon delete" onClick={this.handleDelete} />
            </span>
          </div>
          <span>
            {createdAt === updatedAt &&
              moment(createdAt).format("dddd @ h:mmA - MM.DD.YYYY")}
            {createdAt !== updatedAt &&
              moment(updatedAt).format("dddd @ h:mmA - MM.DD.YYYY [(Edited)]")}
          </span>
          {editNote ? (
            <div className="editFields">
              <TextField
                className="avps_FieldsTextarea textArea"
                type="text"
                margin="normal"
                name="note"
                multiline
                defaultValue={note || ""}
                onChange={event =>
                  this.setState({
                    updatedNoteText: event.target.value
                  })
                }
              />
              <div className="action-container">
                <Button
                  className="save"
                  onClick={() => this.handleUpdateNote()}
                >
                  Save
                </Button>
                <Button className="save" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            <p>{note}</p>
          )}
        </div>
      </NoteStyles>
    );
  }
};

export default connect(
  null,
  { updateNote, deleteNote }
)(Note);
